import { SERVICE_URL } from 'src/environments/tokens';
import { AuthService } from 'src/app/core/services/auth.service';
import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  public serviceUrl;

  constructor(private http: HttpClient,
              private auth: AuthService,
              @Inject(SERVICE_URL) baseUrl: string) {
    this.serviceUrl = baseUrl + 'email/';
  }

  public sendTest(emailDto) {
    return this.http.post(this.serviceUrl+'send/test', emailDto);
  }

  public sendReal(emailDto){
    return this.http.post(this.serviceUrl+'send/real', emailDto);
  }

  public apothekenWithoutLogin() {
    return this.http.get(this.serviceUrl+'apothekenkunden/kein-login');
  }

  public sendLoginReminderEmail(emailDto) {
    return this.http.post(this.serviceUrl+'apothekenkunden/kein-login/email', emailDto);
  }
}
